export function safeReturnPath(value, fallback = "/dashboard") {
  if (typeof value !== "string" || !value.startsWith("/") || value.startsWith("//")) return fallback;
  try {
    const decoded = decodeURIComponent(value);
    if (decoded.startsWith("//") || /[\\\u0000-\u001f\u007f]/.test(decoded)) return fallback;
    const url = new URL(value, window.location.origin);
    if (url.origin !== window.location.origin) return fallback;
    if (url.pathname === "/admin/call-center") {
      const sid = url.searchParams.get("call_sid");
      const params = new URLSearchParams();
      if (sid && /^[a-zA-Z0-9_-]{1,128}$/.test(sid)) params.set("call_sid", sid);
      return url.pathname + (params.size ? `?${params}` : "");
    }
    return url.pathname + url.search + url.hash;
  } catch { return fallback; }
}

export function readReturnPath(explicit, fallback = "/dashboard") {
  if (explicit) return safeReturnPath(explicit, fallback);
  for (const storage of ["sessionStorage", "localStorage"]) {
    try {
      const value = window[storage].getItem("intendedPath");
      if (value) return safeReturnPath(value, fallback);
    } catch { /* A storage denial must not prevent login. */ }
  }
  return fallback;
}